export default "<voting-results data-voting-id=\"\">@{}</voting-results>";